import React from 'react'
import { Modal, FormControl, Button, ButtonToolbar, FormGroup, ControlLabel } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from '../../../component/element/DatePicker'


export default class AddTaskModal extends React.Component {
  // state = {
  //   selectedTask: '',
  //   company: '',
  //   car_registration_no: '',
  //   responsible_name: ''
  // }
  constructor(props) {
    super(props)
    // this.state = {
    //   // selectedTask: '',
    //   company: '',
    //   car_registration_no: '',
    //   responsible_name: '',
    //   taskValue: '',
    //   start_date: '',
    //   end_date: ''
    // }
    this.companyViewCaptions = {
      company: 'ลูกค้า',
      car_registration_no: 'ทะเบียนรถ',
      responsible_name: 'ผู้รับผิดชอบ'
    }
    this.workerViewCaptions = {
      responsible_name: 'ผู้รับผิดชอบ',
      car_registration_no: 'ทะเบียนรถ(ลูกค้า)'
    }
  }

  saveNewTask(meta) {
    return {
      work_no: meta.workNo,
      contractor_id: meta.contractor_id,
      employee_id: meta.employee_id,
      leader_id: '',
      total_cost: '',
      bf_work_damage_id: 0
    }
  }

  getTaskObjects(view) {
    const companyObject =
      this.props.workdocFixingPlanList.filter(
        (obj) => obj.company === view.company)[0]

    return companyObject.worklist.map((obj) => {
      if (obj.car_registration_no !== view.car_registration_no) return null
      const selectedTasks =
        obj.tasklist.filter((task) =>
          task.responsible_name === view.responsible_name
        )
      return selectedTasks
    })[0]
  }

  getTaskObjects(view) {
    const companyObject =
      this.props.workdocFixingPlanList.filter(
        (obj) => obj.company === view.company)[0]

    return companyObject.worklist.map((obj) => {
      if (obj.car_registration_no !== view.car_registration_no) return null
      const selectedTasks =
        obj.tasklist.filter((task) =>
          task.responsible_name === view.responsible_name
        )
      return selectedTasks
    })[0]
  }

  getWorkerViewTaskObjects(view) {
    const splitted = view.car_registration_no.split('(')
    const car_registration_no = splitted[0]
    const company = splitted[1].slice(0, splitted[1].length - 1)

    const companyObject =
      this.props.workdocFixingPlanList.filter(
        (obj) => obj.company === company)[0]

    return companyObject.worklist.map((obj) => {
      if (obj.car_registration_no !== car_registration_no) return null
      const selectedTasks =
        obj.tasklist.filter((task) =>
          task.responsible_name === view.responsible_name
        )
      return selectedTasks
    })[0]
  }

  getTaskOptions() {
    const taskOptions = [{ label: 'รื้อ', value: 'dismanlingState' },
    { label: 'เคาะ', value: 'hitState' },
    { label: 'โป๊ว', value: 'trapState' },
    { label: 'พื้น', value: 'groundState' },
    { label: 'ผสมสี', value: 'mixColorState' },
    { label: 'พ่น', value: 'paintState' },
    { label: 'ประกอบ', value: 'assemblyState' },
    { label: 'ขัดสี', value: 'polishState' },
    { label: 'ล้าง', value: 'cleanState' },
    { label: 'QC', value: 'qcState' }]

    const taskObjects = this.props.maxLevel === 3
      ? this.getTaskObjects(this.props.data.companyView)
      : this.getWorkerViewTaskObjects(this.props.data.workerView)
    if (taskObjects === null || taskObjects.length === 0) return []

    const assignedTasks =
      taskObjects.map((ele) => {
        const tList = ele.tasklist
        return tList[0]['taskValue']
      })
    return taskOptions.filter((ele) => assignedTasks.indexOf(ele.value) === -1)
  }

  isTaskSelected() {
    if (this.props.maxLevel === 3)
      return this.props.data.companyView.taskValue !== ''
    return this.props.data.workerView.taskValue !== ''
  }

  onSaveClick = () => {
    if (typeof this.props.onAddNewTask === 'undefined')
      return

    this.props.onAddNewTask()

    // if (this.props.maxLevel === 3) {
    //   // const meta = this.getMetaForTaskSave(this.props.data.companyView)
    // }

    // var taskId = gantt.addTask({
    //   id: 10,
    //   text: "Task #5",
    //   start_date: "02-09-2013",
    //   duration: 28
    // }, "project_2", 1);
  }

  onNewTaskChange(selectedOption) {
    console.log('selectedOption', selectedOption)
    // this.setState({ taskValue: selectedOption.value })
    this.props.onNewTaskChange(selectedOption.label, selectedOption.value)
  }

  onSelectChange(key, selectedOption) {
    this.props.onSelectChange(key, selectedOption.id, selectedOption.value, this.props.maxLevel)
  }

  onStartDateChange = (dateString, dateMoment) => {
    this.props.onStartDateChange(dateString, dateMoment)
  }

  onEndDateChange = (dateString, dateMoment) => {
    this.props.onEndDateChange(dateString, dateMoment)
  }

  calculateDuration(itemData) {

    // let finishTime = moment(itemData.finishTime.date, 'DD/MM/YYYY')
    // let duration = moment.duration(finishTime.diff(moment(itemData.startTime.date, 'DD/MM/YYYY')));

    // itemData.duration = duration.asDays() + 1;
    // return itemData
  }

  getOptions(key) {
    const children = this.props.allTasks.filter(
      (task) => task.parent === this.props.data.latestSelectedId)
    return children.map((child) => ({
      value: child.name,
      label: child.name,
      id: child.id
    }))
  }

  getWorkerViewOptions(key) {
    const children = this.props.allTasks.filter(
      (task) => task.parent === this.props.data.latestSelectedId)
    return children.map((child) => ({
      value: child.name,
      label: child.name,
      id: child.id
    }))
  }

  /* getOptions(key) {

    const children = this.props.allTasks.filter(
      (task) => (task.parent === this.props.data.latestSelectedId))
    const names = children.map((ele) => ele.name)
    const uniqueNames = [...new Set(names)]
    return uniqueNames.map((uName) => ({
      value: uName,
      label: uName
    }))
  } */

  renderFormGroups() {
    if (typeof this.props.maxLevel === 'undefined')
      return null

    const captions = this.props.maxLevel === 3
      ? this.companyViewCaptions
      : this.workerViewCaptions
    const view = this.props.maxLevel === 3
      ? this.props.data.companyView
      : this.props.data.workerView

    const textInputs = Object.keys(captions).filter((key) => {
      return view[key] !== ''
    }).map((key) => (
      <FormGroup
        // controlId="formBasicText"
        // validationState={this.getValidationState()}
        key={key}
      >
        <ControlLabel>{captions[key]}</ControlLabel>
        <FormControl
          type="text"
          value={view[key]}
          disabled
        />
      </FormGroup>
    ))

    const selectInput = Object.keys(captions).filter((key) => {
      return view[key] === ''
    }).map((key) => (
      <FormGroup
        // controlId="formBasicText"
        // validationState={this.getValidationState()}
        key={key}
      >
        <ControlLabel>{captions[key]}</ControlLabel>
        <Select
          // clearable={false}
          // name='new-task'
          value={view[key]}
          placeholder='เลือกงาน'
          options={
            this.props.maxLevel === 3
              ? this.getOptions(key)
              : this.getWorkerViewOptions(key)
          }
          onChange={this.onSelectChange.bind(this, key)}
        />
      </FormGroup>
    ))[0]

    return selectInput ? textInputs.concat(selectInput) : textInputs
  }

  renderTaskForm() {
    const taskOptions = this.getTaskOptions()
    if (taskOptions.length === 0)
      return (
        <FormGroup>
          <ControlLabel>งานที่ต้องทำทั้งหมดได้ถูกใส่ไปเรียบร้อยแล้ว</ControlLabel>
        </FormGroup>
      )
    return (
      <FormGroup>
        <ControlLabel>งาน</ControlLabel>
        <Select
          // clearable={false}
          name='new-task'
          value={this.props.maxLevel === 3
            ? this.props.data.companyView.taskValue
            : this.props.data.workerView.taskValue}
          placeholder='เลือกงาน'
          options={taskOptions}
          onChange={this.onNewTaskChange.bind(this)}
        />
        <ControlLabel>เวลาเริ่ม</ControlLabel>
        <DatePicker
          // style={{ display: 'inline-block', minWidth: '160px' }}
          showIcon={true}
          showFooter={true}
          buddhistEra
          // value={value}
          onChange={this.onStartDateChange}
        />
        <ControlLabel>เวลาเสร็จ</ControlLabel>
        <DatePicker
          // style={{ display: 'inline-block', minWidth: '160px' }}
          showIcon={true}
          showFooter={true}
          buddhistEra
          popPlacement='top'
          // value={value}
          onChange={this.onEndDateChange}
        />
      </FormGroup >
    )
  }

  isReadyForNewTaskInput() {
    if (this.props.maxLevel === 3) {
      return Object.keys(this.companyViewCaptions).every(
        (key) => this.props.data.companyView[key] !== '')
    }

    return Object.keys(this.workerViewCaptions).every(
      (key) => this.props.data.workerView[key] !== '')
  }

  renderForm() {
    const formGroups = this.renderFormGroups()
    const taskForm = this.isReadyForNewTaskInput()
      ? this.renderTaskForm()
      : null
    return (
      <form>
        {formGroups}
        {taskForm}
      </form>
    )

    /* if (this.props.maxLevel == 3) {
      // customer view
      const formGroups = this.renderFormGroups()
      const taskForm = this.isReadyForNewTaskInput()
        ? this.renderTaskForm()
        : null
      return (
        <form>
          {formGroups}
          {taskForm}
        </form>
      )
    } */

    // worker view
    /* const formGroups = this.renderWorkerViewFormGroups()
    const taskForm = this.isReadyForNewTaskInput()
      ? this.renderTaskForm()
      : null
    return (
      <form>
        {formGroups}
        {taskForm}
      </form>
    ) */
  }

  render() {
    if (!this.props.show) return null
    const saveButton = this.isTaskSelected() && this.getTaskOptions().length > 0
      ? (
        <Button
          bsStyle={'primary'}
          onClick={this.onSaveClick}
        >
          บันทึกงาน
        </Button>
      )
      : null
    return (
      <Modal
        show={this.props.show}
        enforceFocus={false}
        onHide={this.props.onHide}
        bsSize="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มงานใหม่</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {this.renderHeader()} */}
          {this.renderForm()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            {saveButton}
            <Button onClick={this.props.onHide}>ยกเลิก</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/view/workdoc/plan/AddTaskModal.js